import {
  GET_LABREQUESTESSAY_FAIL,
  GET_LABREQUESTESSAY_SUCCESS,
  GET_LABREQUESTESSAYS_FAIL,
  GET_LABREQUESTESSAYS_SUCCESS,
  ADD_LABREQUESTESSAY_SUCCESS,
  ADD_LABREQUESTESSAY_FAIL,
  UPDATE_LABREQUESTESSAY_SUCCESS,
  UPDATE_LABREQUESTESSAY_FAIL,
  DELETE_LABREQUESTESSAY_SUCCESS,
  DELETE_LABREQUESTESSAY_FAIL,  
  SET_STATE_LABREQUESTESSAY
} from "./actionTypes";

const INIT_STATE = {
  labRequestEssays: [],
  labRequestEssay: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequestEssays = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTESSAYS_SUCCESS:
      return {
        ...state,
        labRequestEssays: action.payload.labRequestEssays,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUESTESSAY:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTESSAYS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUESTESSAY_SUCCESS:
      return {
        ...state,
        labRequestEssays: [...state.labRequestEssays, action.payload],
      };

    case ADD_LABREQUESTESSAY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUESTESSAY_SUCCESS:
      return {
        ...state,
        labRequestEssays: state.labRequestEssays.map(labRequestEssay =>
          labRequestEssay.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labRequestEssay }
            : labRequestEssay
        ),
      };

    case UPDATE_LABREQUESTESSAY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUESTESSAY_SUCCESS:
      return {
        ...state,
        labRequestEssays: state.labRequestEssays.filter(
          labRequestEssay => labRequestEssay.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUESTESSAY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTESSAY_SUCCESS:
      return {
        ...state,
        labRequestEssay: action.payload,
      };

    case GET_LABREQUESTESSAY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequestEssays;
